"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSocialIcons = require("react-social-icons");

var _styledComponents = require("styled-components");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Icon = function Icon(_a) {
  var network = _a.network,
      url = _a.url;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return _react["default"].createElement(_reactSocialIcons.SocialIcon, {
    "data-testid": url,
    network: network,
    style: {
      width: 40,
      height: 40
    },
    bgColor: theme.colors.black,
    url: url
  });
};

var _default = Icon;
exports["default"] = _default;